import React from "react";
import classNames from "classnames";
import { pxTransform } from "@/utils";
import type { StandardLonghandProperties } from "csstype";
import { XHComponentCommonProps } from "../../types";

import "./index.scss";

export type XHIcon =
  | "prompt"
  | "score"
  | "info"
  | "failure"
  | "success"
  | "loading"
  | "back"
  | "notice"
  | "scan"
  | "light"
  | "faceScan"
  | "delete"
  | "radioFull"
  | "checkboxFull"
  | "checkedSquare"
  | "checked2"
  | "arrowTop"
  | "notice2"
  | "position"
  | "contacts"
  | "billFull"
  | "bill2"
  | "bill3"
  | "bill4"
  | "edit"
  | "editFull"
  | "camera"
  | "close"
  | "gift"
  | "message"
  | "user"
  | "wenhao"
  | "kefu"
  | "play"
  | "arrowLeft"
  | "arrowRight"
  | "keyboardClose"
  | "add"
  | "tongxunlu"
  | "zhuyi"
  | "duigou"
  | "edit2"
  | "alipay"
  | "wechat"
  | "friendPay"
  | "pen"
  | "location"
  | "search"
  | "qa"
  | "thumbsUp"
  | "thumbsDown"
  | "thumbsUpFull"
  | "thumbsDownFull"
  | "waiting"
  | "scan2"
  | "safety"
  | "report"
  | "forbidden"
  | "unlock"
  | "tel"
  | "download"
  | "medal"
  | "shopCart"
  | "star"
  | "help"
  | (string & {});

export type XHIconProps = {
  icon: XHIcon;
  size?: number;
  color?: StandardLonghandProperties["color"];
  style?: React.CSSProperties;
  onClick?: () => void;
  dataTrackId?: string;
} & XHComponentCommonProps;

const Icon: React.FC<XHIconProps> = props => {
  const { icon = "", size = 0, className, color, style, ...rest } = props;

  const fixIcon = icon && `xh-icon-${icon}`;
  const iconCls = classNames("xh-icon", fixIcon, className);

  const finalStyle: React.CSSProperties = {
    ...style,
    ...(size > 0 ? { fontSize: pxTransform(size) } : {}),
    color,
  };

  return (
    <span
      className={iconCls}
      {...{ style: finalStyle }}
      data-track-id={props.dataTrackId}
      {...rest}
    />
  );
};

export default Icon;
